export const CONSTANTES = {
  EMAIL_ADMIN_NTM: 'ti.ntmsmsrio@gmail.com',
  DOWNLOAD_PLANILHA_ENVIO_INDICADORES: 'informar-indicadores.xlsx',
  FILENAME_MANUAL_DO_SISTEMA: 'guia-aplicacao-web.pdf',
  FILENAME_FICHA_INDICADORES: 'ficha-tecnica-dos-indicadores-do-contrato-de-gestao-N251_2023.pdf'
}
